import React, { useState } from 'react'
import i18next from 'i18next'
import { Menu, MenuItem } from '@szhsin/react-menu'
import '@szhsin/react-menu/dist/index.css'
import { useLanguageManager } from '../../contexts/LocalStorage';
import enIcon from '../../assets/en.png';
import zhIcon from '../../assets/zh.png';

const options = ['中文', 'English'];
const lngOptions = ['zh', 'en'];

function I18nButton({ width }) {
  const [ currentLng, toggleLanguage ] = useLanguageManager();
  const language = currentLng || i18next.language;
  const indexInit = (language === 'zh' || language === 'zh-cn') ? 0 : 1;
  const [ selectedIndex, setSelectedIndex ] = useState(indexInit);

  const handleCloseProfile = index => async event => {
    if (index === selectedIndex) return;
    await i18next.changeLanguage(lngOptions[index])
    toggleLanguage(lngOptions[index]);
    setSelectedIndex(index);
  }

  return (
    <Menu
      menuButton={
        selectedIndex === 0
          ? <img src={zhIcon} width={width} />
          : <img src={enIcon} width={width} />
      }
    >
      {options.map((option, index) => (
        <MenuItem
          type="checkbox"
          checked={index === selectedIndex}
          onClick={handleCloseProfile(index)}
          value={index}
        >{option}</MenuItem>
      ))}
    </Menu>
  )
}

export default I18nButton;